<script>
export default {
  name: "AmsuScholarshipCard",

  props: {
    loading: {
      type: Boolean,
      default: false,
    }
  },
}
</script>

<template>
  <v-card
    flat
    outlined
    class="rounded-xl"
    :loading="loading"
  >
    <slot>

    </slot>

    <template #progress>
      <v-progress-linear color="teal darken-3" indeterminate></v-progress-linear>
    </template>
  </v-card>
</template>

<style scoped>

</style>